module.exports = __webpack_public_path__ + "img/1-index.f6690f11.svg";